import React, { Component } from 'react'
import { Button, Modal, Header, Field, Columns } from '../../elements'
import './favoritesButton.css'
import { compose } from 'recompose'
import withSizes from 'react-sizes'
import { MAP_SIZES_TO_PROPS } from '../../../constants'
import { apiProcess } from 'components/api/api.js'
import { Formik, Form } from 'formik'
import { Subscribe } from 'unstated'
import AppContainer from '../../context/AppContainer'
import { trackNewBikeAddedToFavorites } from 'components/elements/tracking/favoritesTracking'

class FavoritesButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      linkCopied: false,
      viewCreateNewListSection: false,
      bikeAddedToWishlist: props.bikeAddedToWishlist,
      privacy: '',
      newListName: '',
      favoritesData: [],
      favoritesLoading: false,
      disableSaveButton: true,
      privacyOptions: [
        {
          key: 'public',
          text: 'Public',
          value: true,
          content: 'Public',
        },
        {
          key: 'private',
          text: 'Private',
          value: false,
          content: 'Private',
        },
      ],
    }
  }

  setOpen = (open) => {
    this.setState((prevState, props) => ({
      open,
    }))
  }

  showCreateNewListSection = () => {
    this.setState({ viewCreateNewListSection: true })
  }

  loadFavorites = () => {
    this.setState({ favoritesLoading: true })
    const apiURL = 'riders/wishlists/'
    apiProcess(
      apiURL,
      false,
      'get-all-favorites',
      'Get all riders saved motorcycles.'
    )
      .then(
        function(responseData) {
          this.setState({ favoritesLoading: false })
          this.setState({ favoritesData: responseData })
        }.bind(this)
      )
      .catch({
        //any errors and we 404
      })
  }

  validateForm = () => {
    if (this.state.newListName) {
      this.setState({ disableSaveButton: false })
    } else {
      this.setState({ disableSaveButton: true })
    }
  }

  checkAndRedirect = (isAuth, openLoginModal) => {
    if (isAuth) {
      this.loadFavorites()
      this.setOpen(true)
      this.props.onOpen()
    } else {
      openLoginModal(this.bookReservation)
      return false
    }
  }

  handleAddToListClick = (id, bikeID) => {
    const apiURL = 'riders/wishlists/' + id
    let data = {
      motorcycle_uuid: bikeID,
    }
    apiProcess(apiURL, data, 'add-to-list', 'Add this motorcycle to this list.')
      .then(
        function(responseData) {
          trackNewBikeAddedToFavorites(id, bikeID)
          this.setState({ bikeAddedToWishlist: true })
        }.bind(this)
      )
      .catch({
        //any errors and we 404
      })
    this.setState({ open: false })
  }

  handleClose = (event, data) => {
    this.setOpen(false)
  }

  createNewList = () => {
    const apiURL = 'riders/wishlists/'
    let listData = {
      name: this.state.newListName,
      public: this.state.privacy,
    }
    apiProcess(
      apiURL,
      listData,
      'create-new-list',
      'Create a new list for motorcycles.'
    )
      .then(
        function(responseData) {
          this.loadFavorites()
          this.setState({
            viewCreateNewListSection: false,
            disableSaveButton: true,
          })
        }.bind(this)
      )
      .catch({
        //any errors and we 404
      })
  }

  cancel = () => {
    this.setState({ viewCreateNewListSection: false })
  }

  setNewListName = (value) => {
    this.setState({ newListName: value }, () => {
      this.validateForm()
    })
  }

  setPrivacy = (value) => {
    this.setState({ privacy: value }, () => {
      this.validateForm()
    })
  }

  render() {
    const {
      triggerType,
      buttonText,
      bikeID,
      isSearchCardFavourite,
    } = this.props
    return (
      <div className="favorites-button-wrap">
        {triggerType === 'button' && !this.state.bikeAddedToWishlist && (
          <Subscribe to={[AppContainer]}>
            {(auth) => {
              return (
                <Button
                  onClick={(e) => {
                    e.preventDefault()
                    this.checkAndRedirect(auth.state.isAuth, auth.openLogin)
                  }}
                  className={'has-box-shadow favorites-button'}
                >
                  {/* {isMobile === true || isSearchCardFavourite ? (
                    <i className="far fa-heart fa-lg"></i>
                  ) : (
                    <i className="far fa-heart"></i>
                  )}{' '}
                  Save */}
                  <i className="far fa-heart fa-lg"></i>
                  {/* {!isMobile && buttonText.length > 0 && <>{buttonText}</>} may reuire in future*/}
                </Button>
              )
            }}
          </Subscribe>
        )}
        {triggerType === 'button' && this.state.bikeAddedToWishlist && (
          <Button
            className={'has-box-shadow favorites-button-added'}
            onClick={(e) => e.preventDefault()}
          >
            {<i className="fas fa-heart fa-lg red-color"></i>}
            {/* {!isMobile && <>Saved</>} may require in future*/}
          </Button>
        )}
        {triggerType === 'text' && (
          <div onClick={this.handleTriggerClick}>{buttonText}</div>
        )}
        <Modal
          show={this.state.open}
          closeOnEsc={true}
          closeOnBlur={true}
          onClose={this.handleClose}
          size="auto"
        >
          <div className="favorites-pop-modal">
            <Header
              renderas={'h2'}
              size={4}
              className="has-text-weight-extra-bold"
            >
              Save to list
            </Header>

            <div className="favorites-button-options">
              {!this.state.viewCreateNewListSection && (
                <div className="favorites-button-option-item">
                  <a href="#" onClick={() => this.showCreateNewListSection()}>
                    Create new list
                  </a>
                </div>
              )}

              {this.state.viewCreateNewListSection && (
                <div className="favorites-button-option-item">
                  <div className="content">
                    <Formik>
                      <Form>
                        <Columns.Column size={12}>
                          <Field
                            label="List Name"
                            type="input"
                            name="listName"
                            id="listName"
                            fullwidth="true"
                            value={this.state.newListName}
                            onChange={({ value }) => {
                              this.setNewListName(value)
                            }}
                          />
                        </Columns.Column>
                        {/* <Columns.Column size={12}>
                          <Field
                            label="Privacy"
                            fullwidth="true"
                            type="select"
                            options={this.state.privacyOptions}
                            id="privacy"
                            name="privacy"
                            value={this.state.privacy}
                            onChange={({ e, value }) => {
                              this.setPrivacy(value)
                            }}
                          />
                        </Columns.Column> */}
                      </Form>
                    </Formik>
                    <Columns className="is-mobile buttons-row">
                      <Columns.Column size={6}>
                        <Button
                          size="medium"
                          onClick={() => this.cancel()}
                          className="cancel-button"
                          color="#b9995b"
                          fullwidth="true"
                          outlined
                        >
                          Cancel
                        </Button>
                      </Columns.Column>
                      <Columns.Column size={6}>
                        <Button
                          size="medium"
                          fullwidth="true"
                          color="primary"
                          disabled={this.state.disableSaveButton}
                          onClick={() => this.createNewList()}
                        >
                          Save
                        </Button>
                      </Columns.Column>
                    </Columns>
                  </div>
                </div>
              )}

              {this.state.favoritesLoading && (
                <Columns.Column size={12}>
                  <div className="has-text-centered">
                    <i className="fas fa-2x fa-cog fa-spin"></i>
                    <div className="saving-changes">
                      Loading your favorites lists
                    </div>
                  </div>
                </Columns.Column>
              )}
              {this.state.favoritesData?.wishlists &&
                !this.state.favoritesLoading && (
                  <div>
                    {this.state.favoritesData.wishlists.map((data, index) => (
                      <div className="favorites-button-option-item">
                        <span
                          className="copy-link-wrap"
                          onClick={() => {
                            this.handleAddToListClick(data.uuid, bikeID)
                          }}
                        >
                          <div className="favorites-button-item-title">
                            <div className="favorites-button-item-title-inner">
                              {data.name}
                            </div>
                          </div>
                          <div className="favorites-button-item-icon">
                            <div className="favorites-button-item-icon-inner">
                              <i className="fal fa-plus"></i>
                            </div>
                          </div>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default compose(withSizes(MAP_SIZES_TO_PROPS))(FavoritesButton)

FavoritesButton.defaultProps = {
  color: 'white', //can also be primary
  quote: 'Twisted Road',
  url: 'https://www.twistedroad.com',
  buttonText: 'Share',
  onOpen: () => {},
  triggerType: 'button', //or text
}
